import React, { Component } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import NavigationBar from '../NavigationBar';
import Footer from '../Footer/Footer';
import keyService from '../../services/keyService';
import './EncryptedTextView.css';

class EncryptedTextView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      isLoading: true,
      error: null,
      showEncryptionKey: false
    };
  }

  async componentDidMount() {
    try {
      // Fetch the message by ID
      const message = await keyService.getMessageById(this.props.messageId);
      this.setState({ message, isLoading: false });
    } catch (error) {
      this.setState({ 
        error: error.message || 'Failed to load message', 
        isLoading: false 
      });
    }
  }

  toggleEncryptionKeyVisibility = () => {
    this.setState({ showEncryptionKey: !this.state.showEncryptionKey });
  }

  handleDeleteClick = async () => {
    if (window.confirm('Are you sure you want to delete this message?')) {
      try {
        await keyService.deleteMessage(this.props.messageId);
        this.props.navigate('/messages');
      } catch (error) {
        this.setState({ 
          error: 'Failed to delete message'
        });
      }
    }
  }

  renderMessageDetails() {
    const { message } = this.state;
    
    if (!message) return null;
    
    return (
      <div className="message-details">
        <div className="message-header-details">
          <h2 className="message-title">
            <i className="fa fa-file-lines" aria-hidden="true"></i> {message.subject || 'Untitled Message'}
          </h2>
          <div className="message-meta">
            <div className="message-date">
              <i className="fa fa-calendar" aria-hidden="true"></i> Created on {moment(message.created_at).format('MMMM D, YYYY')}
            </div>
          </div>
        </div>
        
        <div className="message-body">
          {message.keys && message.keys.length > 0 && (
            <div className="encryption-keys-section">
              <h4><i className="fa fa-key" aria-hidden="true"></i> Encryption Keys</h4>
              <div className="keys-list">
                {message.keys.map(keyData => {
                  const keyDetails = keyData.keys;
                  return (
                    <div key={keyData.key_id} className="key-item">
                      <div className="key-header">
                        <div className="key-name">
                          {keyDetails?.name || 'Unnamed Key'}
                        </div>
                        <button 
                          className="key-toggle-btn"
                          onClick={this.toggleEncryptionKeyVisibility}
                        >
                          {this.state.showEncryptionKey ? 'Hide' : 'Show'} Key
                        </button>
                      </div>
                      {this.state.showEncryptionKey && (
                        <div className="key-content">
                          <div className="key-value">{keyDetails?.encryption_key}</div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
        
        <div className="message-actions-footer">
          <Link to="/messages" className="btn btn-outline-secondary">
            <i className="fa fa-arrow-left" aria-hidden="true"></i> Back to Messages
          </Link>
          <button onClick={this.handleDeleteClick} className="btn btn-outline-danger">
            <i className="fa fa-trash" aria-hidden="true"></i> Delete Message
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { isLoading, error } = this.state;
    
    return (
      <>
        <NavigationBar />
        <div className="container view-container">
          <div className="row justify-content-center">
            <div className="col-md-10">
              <div className="view-card">
                {isLoading ? (
                  <div className="text-center p-5">
                    <i className="fa fa-spinner fa-spin fa-2x" aria-hidden="true"></i>
                    <p className="mt-2">Loading message...</p>
                  </div>
                ) : error ? (
                  <div className="alert alert-danger" role="alert">
                    <i className="fa fa-exclamation-triangle" aria-hidden="true"></i> {error}
                    <div className="mt-3">
                      <Link to="/messages" className="btn btn-outline-secondary">
                        <i className="fa fa-arrow-left" aria-hidden="true"></i> Back to Messages
                      </Link>
                    </div>
                  </div>
                ) : (
                  this.renderMessageDetails()
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

EncryptedTextView.propTypes = {
  messageId: PropTypes.string.isRequired,
  navigate: PropTypes.func.isRequired
};

// Wrapper to get URL parameters and navigation function
const EncryptedTextViewWrapper = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  return <EncryptedTextView {...props} messageId={id} navigate={navigate} />;
};

export default EncryptedTextViewWrapper;
